import { takeLatest, call, put } from 'redux-saga/effects'
import certificatesList from 'api/administration/certificates/List'
import createCertificate from 'api/administration/certificates/Create'

import * as fromActions from 'store/actions/certificates.action'
import { ICertificate } from 'models/certificate.model'

import { ErrorToast, SuccessToast } from 'components/ui/toast/toastsTemplates'
import I18n from 'i18n'

async function getList() {
  return await certificatesList()
}

async function handleCreate(data: ICertificate) {
  return await createCertificate(data)
}

function* createCertificateEffectSaga(action: any) {
  try {
    const { certificate } = action.payload
    yield call(handleCreate, certificate)
    const { data } = yield call(getList)
    yield put(fromActions.Actions.certificateAdministrationListSuccess(data))

    SuccessToast(I18n.t('administration.toastMessages.certificateCreateSuccess'))
  } catch (error) {
    ErrorToast(I18n.t('administration.toastMessages.certificateCreateError'))
    console.log('error: ', error)
  }
}

export function* createCertificateWatcherSaga() {
  yield takeLatest(fromActions.CREATE_CERTIFICATE, createCertificateEffectSaga)
}